import { render, staticRenderFns } from "./SegmentException.vue?vue&type=template&id=640bca78&scoped=true&"
import script from "./SegmentException.vue?vue&type=script&lang=js&"
export * from "./SegmentException.vue?vue&type=script&lang=js&"
import style0 from "./SegmentException.vue?vue&type=style&index=0&id=640bca78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640bca78",
  null
  
)

export default component.exports